import React from "react";
import {
  View,
  StyleSheet
} from "react-native";

const styles = StyleSheet.create({
	dialogContainer: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		alignItems: "center",
		justifyContent: "center",
		zIndex: 1,
		backgroundColor: "rgba(0,0,0,0.8)"
	}
});

export default function DialogContainer(props){
	const children = props.children;
	return (
		<View style={styles.dialogContainer}>
			{children}
		</View>
	);
}
